module.exports = __webpack_public_path__ + "static/media/notification-sound.a6b2845f.mp3";